"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var apiService_1 = __importStar(require("@common/services/apiService"));
var ItemLogPage_1 = __importDefault(require("@features/ItemLogPage"));
var Button_1 = __importDefault(require("@/react-app/common/components/Button"));
var SwitchBox_1 = __importDefault(require("@/react-app/common/components/SwitchBox"));
var notifier_1 = __importDefault(require("@/react-app/common/utils/notifier"));
var i18n_1 = __importDefault(require("@/react-app/i18n"));
var string_1 = require("@/react-app/common/utils/string");
var BlangEditor_1 = require("@/react-app/common/components/BlangEditor");
var Loading_1 = __importDefault(require("@/react-app/common/components/Loading"));
function FilterMatchedItemsPage(_a) {
    var _this = this;
    var angularJsDependencies = _a.angularJsDependencies, domain = _a.domain, ruleId = _a.ruleId;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = __read((0, react_1.useState)(), 2), rule = _b[0], setRule = _b[1];
    var _c = __read((0, react_1.useState)(false), 2), hasError = _c[0], setHasError = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), isLoading = _d[0], setIsLoading = _d[1];
    var _e = __read((0, react_1.useState)(''), 2), errorText = _e[0], setErrorText = _e[1];
    var canUserEditFilter = angularJsDependencies.userPermissionManager.getPermissionForOperation('automation:rule', domain).canWrite;
    var getNoticeText = function (ruleNotice) {
        if (ruleNotice.enabled) {
            return " ".concat(ruleNotice.text, " (").concat((0, string_1.upperCaseFirstLetter)(ruleNotice.severity), ")");
        }
        return 'Disabled';
    };
    var getFilterAction = function (rule) {
        switch (rule.result) {
            case 'REFUSE':
                return "Refuse (".concat(rule.decisionName, ")");
            case 'MANUAL':
                return "Send to manual moderation ".concat(rule.routingQueueName, " queue");
            case 'NOTHING':
                return t('AUTOMATION.DECISION_RULES.RULE_BUILDER.ACTIONS.NO_ACTION_LABEL');
            default:
                return (0, string_1.upperCaseFirstLetter)(rule.result);
        }
    };
    var fetchRuleById = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, error_1, errorMsg_1, errorMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setIsLoading(true);
                    setHasError(false);
                    return [4 /*yield*/, apiService_1.default.getRuleById({ domain: domain, id: ruleId })];
                case 1:
                    response = _a.sent();
                    setRule(response.data);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    setHasError(true);
                    if ((0, apiService_1.isApiError)(error_1) && error_1.status === 404) {
                        errorMsg_1 = t('AUTOMATION.DECISION_RULES.ERROR.NO_RULE_MATCHED_REACT', { ruleId: ruleId });
                        setErrorText(errorMsg_1);
                        return [2 /*return*/];
                    }
                    errorMsg = t('AUTOMATION.DECISION_RULES.ERROR.LOADING_ERROR');
                    setErrorText(errorMsg);
                    return [3 /*break*/, 4];
                case 3:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var updateFilterStatusHandler = function (enabled) { return __awaiter(_this, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!rule) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiService_1.default.updateRuleStatus({ domain: domain, id: ruleId }, { enabled: enabled })];
                case 2:
                    _a.sent();
                    setRule(__assign(__assign({}, rule), { enabled: enabled }));
                    notifier_1.default.success(i18n_1.default.t('AUTOMATION.DECISION_RULES.STATUS.SUCCESS_TEXT_REACT', { ruleName: rule.name }));
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    setHasError(true);
                    notifier_1.default.error(i18n_1.default.t('AUTOMATION.DECISION_RULES.STATUS.ERROR_TEXT_REACT', { ruleName: rule.name }));
                    // in angularjs in error case we are fetching the rule again
                    fetchRuleById();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        fetchRuleById();
    }, []);
    if (isLoading) {
        return react_1.default.createElement(Loading_1.default, null);
    }
    return (react_1.default.createElement("div", { className: "filter-view content" },
        hasError && !isLoading && (react_1.default.createElement("div", { className: "loading-error" },
            react_1.default.createElement("h2", null, errorText),
            react_1.default.createElement(Button_1.default, { onClick: fetchRuleById, text: t('AUTOMATION.DECISION_RULES.BTN.TRY_AGAIN') }))),
        !hasError && rule && !isLoading && (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-md-6" },
                    react_1.default.createElement("h3", { className: "page-title" }, t('AUTOMATION.DECISION_RULES.RULE_VIEW.TITLE_REACT', { ruleName: rule === null || rule === void 0 ? void 0 : rule.name }))),
                react_1.default.createElement("div", { className: "col-md-6" },
                    react_1.default.createElement("span", { className: "pull-right" }, canUserEditFilter && (react_1.default.createElement(Button_1.default, { text: t('AUTOMATION.DECISION_RULES.RULE_VIEW.EDIT_RULE_BTN'), leftIcon: react_1.default.createElement("i", { className: "implioicons-edit" }), onClick: function () {
                            return angularJsDependencies.go('app.assignment.automation.filterEdit', {
                                domain: domain,
                                filterId: ruleId,
                            });
                        }, dataCy: "edit-rule" }))))),
            react_1.default.createElement("div", { className: "row rule-details" },
                react_1.default.createElement("div", { className: "col-md-12 filter-status-container" },
                    react_1.default.createElement("span", { className: "filter-status" },
                        react_1.default.createElement("b", { className: "capitalize" }, t('AUTOMATION.DECISION_RULES.RULE_VIEW.STATUS_LABEL')),
                        canUserEditFilter && react_1.default.createElement(SwitchBox_1.default, { checked: rule.enabled, onToggle: function (e) { return updateFilterStatusHandler(e); } }),
                        !canUserEditFilter && react_1.default.createElement("span", null,
                            "\u00A0",
                            rule.enabled ? 'ON' : 'OFF')),
                    getFilterAction(rule) && (react_1.default.createElement("span", { className: "filter-option" },
                        react_1.default.createElement("b", null,
                            t('AUTOMATION.DECISION_RULES.RULE_VIEW.ACTION_LABEL'),
                            ":"),
                        " ",
                        getFilterAction(rule))),
                    rule.notice && (react_1.default.createElement("span", { className: "filter-option" },
                        react_1.default.createElement("b", null,
                            t('AUTOMATION.DECISION_RULES.RULE_VIEW.NOTICE_LABEL'),
                            ":"),
                        " ",
                        getNoticeText(rule.notice))))),
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-md-12" },
                    react_1.default.createElement(BlangEditor_1.BlangEditor, { editable: false, value: rule.rule, maxHeight: "300px" }))),
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-md-12 clearfix table-input search-section" },
                    react_1.default.createElement("h3", null, t('AUTOMATION.DECISION_RULES.RULE_VIEW.ITEM_LOG_TITLE')))),
            rule.lastModifiedTime && (react_1.default.createElement("div", { className: "job-search" },
                react_1.default.createElement(ItemLogPage_1.default, { domain: domain, filterViewDefaultStartDate: rule.lastModifiedTime, filterId: ruleId, angularJsDependencies: angularJsDependencies })))))));
}
exports.default = FilterMatchedItemsPage;
